import React, { Component } from 'react';
import {observer} from 'mobx-react'
import styles from '../index.css';
import localStyles from './index.css';
import FontAwesome from 'react-fontawesome';
import {Bunker, Truck, RailCart, Bubbles} from '../SubComponents/index';
import {date, shipment} from '../../../stores/index';
import fonts from "../../../../iconfonts.css";

@observer
export default class OutputFlow extends Component {

    state = {active:false};

    shouldComponentUpdate(nextProps,nextState) {
        return nextState.active !== this.state.active;
    }

    activeToggle() {
        this.state.active
            ? this.setState({active:false})
            : this.setState({active:true})
    }



    render() {
        return (
            <div className={styles.innerContainer + ' ' + styles.outputFlow + (this.state.active ? ' ' + styles.activeTab : '')}>
                <div className={styles.content}>
                    <div className={styles.queueContainer}>

                        <div className={styles.stateToggleButton} onClick={this.activeToggle.bind(this)}>
                            {(this.state.active ? <FontAwesome name='compress' /> : <FontAwesome name='expand' />)}
                        </div>
                        <div className={styles.indicator} style={{left:0}}>
                            <div className={localStyles.indicatorCircle + ' ' + localStyles.wheat}>
                                {shipment.getTotalWheat}
                            </div>
                            <div className={localStyles.indicatorCircle + ' ' + localStyles.rape}>
                                {shipment.getTotalRape}
                            </div>
                            <div className={localStyles.indicatorCircle + ' ' + localStyles.soy}>
                                {shipment.getTotalSoy}
                            </div>
                            <div className={localStyles.indicatorCircle + ' ' + localStyles.sunflower}>
                                {shipment.getTotalSunflower}
                            </div>
                            <div className={localStyles.indicatorCircle + ' ' + localStyles.corn}>
                                {shipment.getTotalCorn}
                            </div>
                        </div>
                        <div className={localStyles.bunkerContainer}>
                            {shipment.shipmentBunker.map((item,i)=>{
                              return(  <div className={localStyles.bunkerRow} key={i} onClick={()=>{console.log(item.type,item)}}>
                                    <Bunker item={item} i={i} output={true}/>
                                    <div className={localStyles.truckRailCartHolder}>
                                        {item.activeTransport.disabled ? null :
                                            item.bunkerType === "train" ?
                                                <RailCart item={item.activeTransport}/>
                                                :
                                                <Truck item={item.activeTransport} backwards={false}/>
                                        }
                                    </div>
                                </div>
                              )})}
                        </div>
                        <div className={localStyles.queues + (!this.state.active ? ' ' +  localStyles.noBorder : '' )} >
                            <div className={localStyles.bulkQueue}>
                                <OutputStack />
                            </div>
                            <div className={localStyles.nearestQueue}>
                                <CompositionFormation />
                            </div>
                        </div>
                        <div className={styles.queueBubbles}>
                            <Bubbles culture={shipment.getLineStatus} />
                        </div>
                        <div className={localStyles.outputLine + ' ' + localStyles[shipment.getLineStatus]} />
                    </div>
                </div>
            </div>
        );
    }
}



@observer
class OutputStack extends Component{


    render(){
        return(
            <div className={localStyles.outputStackContainer}>
                {shipment.outputTransport.map((item,i)=>{
                    return <OutputTransport {...item} key={i}/>
                })}

                {/*<OutputTransport type={'train'} startDate={new Date()} endDate={new Date()}/>*/}
                {/*<OutputTransport type={'train'} startDate={new Date()} endDate={new Date()}/>*/}
                {/*<OutputTransport type={'train'} startDate={new Date()} endDate={new Date()}/>*/}
                {/*<OutputTransport type={'truck'} startDate={new Date()} endDate={new Date()}/>*/}
            </div>
        )
    }
}


const OutputTransport = (props)=>{
    return(
        <div className={localStyles.transportElement}>
            <div>
                {props.type ==='train' ? <RailCart item ={{moistureLevel:props.moistureLevel,wasteLevel:props.wasteLevel,culture:props.culture, groupQuantity:props.quantity,amount:0}}/>
                    :
                    (props.type === 'truck' ?
                        <Truck item ={{moistureLevel:props.moistureLevel,wasteLevel:props.wasteLevel,culture:props.culture, groupQuantity:props.quantity,amount:0}}/>
                        :
                        null)}
            </div>
            <div className={localStyles.description}>
                <div><span>Прибытие:</span> <span>{props.dateIncome.toLocaleDateString('ru',{ year: 'numeric', month: 'numeric', day: 'numeric' })}</span></div>
                <div><span>Отправка:</span> <span>{props.endDate.toLocaleDateString('ru',{ year: 'numeric', month: 'numeric', day: 'numeric' })}</span></div>
            </div>
        </div>
    )
};

@observer
class CompositionFormation extends Component{
    state = {selectedCrop:0};
    setCrop(id){
        this.setState({selectedCrop:id});

    }

    render(){
        const culture=['wheat','rape','soy','sunflower','corn']
        return(
            <div className={localStyles.compositionFormation}>
                <div>
                    <div className={localStyles.columnCrops}>
                        <div className={localStyles.cultureCircle + ' ' + localStyles.wheat + (this.state.selectedCrop === 0 ? ' ' + localStyles.selected : '')} onClick={()=>{this.setCrop(0)}}>
                            <i className={fonts.wheat}/>
                        </div>
                        <div className={localStyles.cultureCircle + ' ' + localStyles.rape + (this.state.selectedCrop === 1 ? ' ' + localStyles.selected : '')} onClick={()=>{this.setCrop(1)}}>
                            <i className={fonts.rape}/>
                        </div>
                        <div className={localStyles.cultureCircle + ' ' + localStyles.soy + (this.state.selectedCrop === 2 ? ' ' + localStyles.selected : '')} onClick={()=>{this.setCrop(2)}}>
                            <i className={fonts.soy}/>
                        </div>
                        <div className={localStyles.cultureCircle + ' ' + localStyles.sunflower + (this.state.selectedCrop === 3 ? ' ' + localStyles.selected : '')} onClick={()=>{this.setCrop(3)}}>
                            <i className={fonts.sunflower}/>
                        </div>
                        <div className={localStyles.cultureCircle + ' ' + localStyles.corn + (this.state.selectedCrop === 4 ? ' ' + localStyles.selected : '')} onClick={()=>{this.setCrop(4)}}>
                            <i className={fonts.corn}/>
                        </div>
                    </div>
                </div>
                <div className={(date.compositionFormation ? localStyles.messageActive : localStyles.message)}>Выбранный вами состав прибудет уже завтра, дождитесь его прибытия!!</div>
                <div className={localStyles.buttonContainer}>
                    <div className={localStyles.menuButton + (!date.compositionFormation ? ' ' + localStyles.active: '')} onClick={()=>{date.setCompositionFormation(culture[this.state.selectedCrop])}}>Сформировать состав</div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/Game/OutputFlow/index.js